import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectWithdraw, withdrawActions } from "Shared/store/withdraw";
import { Button, Modal } from "Shared/ui";
import { WithdrawTaxDesciption, WithdrawTaxInfo } from "Widgets/withdraw_amount/components";
import { taxSelect } from "Pages/Withdraw/store";
import { api } from "Shared/axios";
import { LoadingWidget } from "Shared/ui/loaders/loading_widget";
import "../withdraw_modals.scss";

export const TaxInfoModal = () => {
	const dispatch = useDispatch();
	const isVisible = useSelector(selectWithdraw.isVisibleTaxInfo);
	const withdrawParams = useSelector(selectWithdraw.withdrawParams);
	const tax_data = useSelector(taxSelect.all);
	const [isLoading, setIsLoading] = useState(false);
	const [calculatedTax, setCalculatedTax] = useState(undefined);

	function onClose() {
		dispatch(withdrawActions.setIsVisibleTaxInfo(false));
		dispatch(withdrawActions.setWithdrawParams(null));
	}
	function onAccept() {
		dispatch(withdrawActions.setIsVisibleTaxInfo(false));
		dispatch(withdrawActions.setVisibleUpdateAcc(true));
	}

	async function calculateTax() {
		setIsLoading(true);
		try {
			const response = await api.get("/payment/request-tax", { params: { amount: withdrawParams.amount } });
			setCalculatedTax(response.data);
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	}

	const buttons = [<Button type="azure" key={"ok"} text="Accept" onClick={onAccept} />];

	return (
		<Modal
			isVisible={isVisible}
			buttons={buttons}
			title={"Income Tax"}
			onClose={onClose}
			onVisibleCallback={calculateTax}
		>
			{!isLoading ? (
				<div className="withdraw-modal">
					<WithdrawTaxInfo
						taxPercent={tax_data.tax_percent}
						inputAmount={withdrawParams?.amount}
						calculated={calculatedTax}
					/>
					<WithdrawTaxDesciption tax={tax_data.tax_percent} limit={tax_data.tax_free_amount} />
				</div>
			) : (
				<div className="withdraw-modal">
					<LoadingWidget />
				</div>
			)}
		</Modal>
	);
};
